import { REVISIONED_LINE_ITEM_TYPES, type Currency, type RevisionedLineItem } from '@weft/types';
import { isNullOrUndefined } from '@weft/utils';
import { formatNumber } from '@weft/utils';
import { getCurrencySymbol } from 'apps/app/src/services/currency-symbol-mapper';
import React from 'react';
import { LightInvoiceProductSection } from './LightInvoiceProductSection';

type LightInvoiceFixedFeeChargesProps = {
  revisionedLineItems: RevisionedLineItem[]
  isPdf?: boolean;
  currency: Currency;
};

export const LightInvoiceRevisionedLineItem:React.FC<LightInvoiceFixedFeeChargesProps> = ({
  revisionedLineItems,
  isPdf,
  currency,
}) => {
  const currencySymbol = getCurrencySymbol(currency);

  return (
    <div className="space-y-5">
      {revisionedLineItems.map((lineItem) => {
        return isNullOrUndefined(lineItem.baseLineItemId)
          ? (
            <LightInvoiceProductSection
              key={lineItem.id}
              name={lineItem.name}
              price={getFormattedPriceWithSign(lineItem, currencySymbol)}
              description={lineItem.description}
              isPdf={isPdf}
            />
          )
          : null;
      })}
    </div>
  );
};

const getFormattedPriceWithSign = (lineItem: RevisionedLineItem, currencySymbol: string) => {
  return lineItem.type === REVISIONED_LINE_ITEM_TYPES.PercentagePromotion ||
    lineItem.type === REVISIONED_LINE_ITEM_TYPES.FixedPromotion 
    ? '-' + getFormattedPrice(lineItem, currencySymbol) 
    : getFormattedPrice(lineItem, currencySymbol);
};

const getFormattedPrice = (lineItem: RevisionedLineItem, currencySymbol: string) => {
  return `${currencySymbol}${formatNumber(lineItem.price)}`;
};